import { Alert, Button } from '@mui/material'
import axios from 'axios'
import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'

const VerifiedEmail = () => {

  const params = useParams()
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/auth/verify/${params.userId}/${params.uniqueString}`)
  }, []);

  return (
    <div style={{height: '100vh', marginTop: '70px'}}>
      <Alert severity="info" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0;'}}>
        <h3>Your email has been verified. You can login in the app.</h3>
        <Button variant="contained" style={{marginBottom: '20px', width: '100px'}}>
          <Link style={{textDecoration: 'none', color: '#fff', fontWeight: 'bold'}} to="/login">Login</Link>
        </Button>
      </Alert>
    </div>

  )
}

export default VerifiedEmail